import { FiArrowLeft } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const GoBack = ({ prevHref }: { prevHref?: string }) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (prevHref) {
      navigate(prevHref);
    } else {
      navigate(-1); 
    }
  };

  return (
    <button
      className="bg-[#88087B] hover:bg-purple-700 text-white rounded-full p-2 focus:outline-none"
      onClick={handleGoBack}
    >
      <FiArrowLeft />
    </button>
  );
};

export default GoBack;
